import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=95f15b5e&scoped=true"
import script from "./Cgu.vue?vue&type=script&lang=ts"
export * from "./Cgu.vue?vue&type=script&lang=ts"
import style0 from "./Cgu.vue?vue&type=style&index=0&id=95f15b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f15b5e",
  null
  
)

export default component.exports